export function applyThemeToCss(theme = {}) {
  const root = document.documentElement;
  const map = {
    "--color-primary":        theme.primaryColor      || "#2563eb",
    "--color-primary-dark":   theme.primaryColorDark  || "#1d4ed8",
    "--color-primary-hover":  theme.primaryHover       || "#3b82f6",
    "--color-sidebar-bg":     theme.sidebarBg         || "#1a2035",
    "--color-header-bg":      theme.headerBg          || "#ffffff",
    "--color-accent":         theme.accentColor       || "#34d399",
    "--color-sidebar-text":   theme.sidebarText       || "#b3b9c4",
    "--color-sidebar-active": theme.sidebarActive     || "#ffffff",
    "--font-family-base":     theme.fontFamily        || "'Poppins', sans-serif",
  };
  Object.entries(map).forEach(([prop, value]) => root.style.setProperty(prop, value));
}

export function applyFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}
